import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/LogoThotex.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-33d1273f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Iniciar sesión", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Correo electrónico", -1))
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contraseña", -1))
const _hoisted_8 = {
  key: 1,
  class: "error"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message" }, [
  /*#__PURE__*/_createTextVNode("Olvidaste tu contraseña? "),
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Recuperar contraseña")
], -1))

import { Ref, ref } from 'vue';
  
  import AuthService from '@/services/AuthService';
  import { IUserForm } from '@/interfaces/IUsers';
  import router from '@/router';
  import swal from 'sweetalert';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  emits: ['closeFormLogin'],
  setup(__props, { emit: __emit }) {

  const userForm: Ref<IUserForm> = ref({
    email: '',
    password: '',
  })

  const errors : Ref<{email: boolean, password: boolean}> = ref({
      email: false,
      password: false,
  })

  const error_messages : Ref<{email: string, password: string}> = ref({
      email: '',
      password: '',
  })

  const verifyEmail = () : boolean => {
      if (userForm.value.email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
          return true
      }
      else {
          errors.value.email = true
          error_messages.value.email = 'Email no valido'
          return false
      }
  }

  const verifyPassword = () : boolean => {
    // Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character
    if (!(
          //lowercase letter
          userForm.value.password.match(/[a-z]/g) &&
          //uppercase letter
          userForm.value.password.match(/[A-Z]/g) &&
          //number
          userForm.value.password.match(/[0-9]/g) &&
          //special character
          userForm.value.password.match(/[@$!%*?&]/g) &&
          //8 characters length
          userForm.value.password.length >= 8
        )) {
      errors.value.password = true
      error_messages.value.password = 'La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial'
      return false
    }
    else {
      return true
    }
  }

  const checkNonEmptyInputs = () : boolean => {
      const defaultValues : IUserForm = {
          email: '',
          password: '',
      }

      let isFormValid = true

      if (userForm.value.email === defaultValues.email) {
          errors.value.email = true
          error_messages.value.email = 'El correo electrónico es obligatorio'
          isFormValid = false
      }

      if (userForm.value.password === defaultValues.password) {
          errors.value.password = true
          error_messages.value.password = 'La contraseña es obligatoria'
          isFormValid = false
      }

      return isFormValid
      
  }

  /**
   * Verify the form by checking non-empty inputs, email, and password validity.
   *
   * @return {boolean} the validity of the form inputs
   */
  const verifyForm = () : boolean => {
      if (checkNonEmptyInputs()) {
          //Verify at a time
          let validInputs = true
          if (!verifyEmail()) {
              validInputs = false
          }
          if (!verifyPassword()) {
              validInputs = false
          }
          return validInputs
      }
      else {
          return false
      }
  }

  const emits = __emit

  const closeComponent = () => {
      emits('closeFormLogin')
  }

  const authUser = async () : Promise<boolean> => {
    if (verifyForm()) {
      const auth : AuthService = new AuthService();
      //TODO : MOVER A UNA INTERFAZ APARTE Y MODIFICAR EL AUTH PARA RECIBIR OBJETO USER
      const response : boolean = await auth.login(userForm.value);
      if (response) {
        router.push({ name: 'portal' })
        return true;
      } else {
        swal("¡Login fallido!", auth.getError().value , "error");
        return false;
      } 
    }
    else {
      return false
    }
  }
      


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "login modal",
    onClick: closeComponent
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "form",
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("form", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            required: "",
            type: "email",
            placeholder: "Correo electrónico",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userForm.value.email) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => {errors.value.email = false; error_messages.value.email = ''})
          }, null, 544), [
            [_vModelText, userForm.value.email]
          ]),
          (errors.value.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error_messages.value.email), 1))
            : _createCommentVNode("", true),
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            required: "",
            type: "password",
            placeholder: "Contraseña",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userForm.value.password) = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => {errors.value.password = false; error_messages.value.password = ''})
          }, null, 544), [
            [_vModelText, userForm.value.password]
          ]),
          (errors.value.password)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error_messages.value.password), 1))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createElementVNode("button", {
            onClick: _withModifiers(authUser, ["prevent"])
          }, "Iniciar sesión")
        ])
      ])
    ])
  ]))
}
}

})